<template>
    <div class="ui-drawer-panel flex flex-col h-full text-sm">
        <div
            class="ui-drawer-panel__header flex items-center justify-between gap-2 px-4 py-3 border-b border-gray-200 dark:border-zinc-700 shrink-0"
        >
            <slot name="header">
                <span class="font-semibold truncate">{{ title }}</span>
            </slot>
            <div class="flex items-center gap-2 shrink-0">
                <slot name="header-actions" />
                <button
                    v-if="closable"
                    type="button"
                    class="opacity-60 hover:opacity-100 px-1"
                    dusk="drawer-panel-close"
                    @click="$emit('close')"
                >
                    ✕
                </button>
            </div>
        </div>

        <ui-scrollable class="ui-drawer-panel__body flex-1 min-h-0">
            <div class="px-4 py-3">
                <slot />
            </div>
        </ui-scrollable>

        <div
            v-if="$slots.footer"
            class="ui-drawer-panel__footer px-4 py-3 border-t border-gray-200 dark:border-zinc-700 shrink-0"
        >
            <slot name="footer" />
        </div>
    </div>
</template>

<script setup lang="ts">
withDefaults(
    defineProps<{
        /** Header title (ignored when the #header slot is used). */
        title?: string;
        /** Render the built-in close button emitting `close`. */
        closable?: boolean;
    }>(),
    {
        title: '',
        closable: true,
    },
);

defineEmits<{ close: [] }>();
</script>
